import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "body__icon" }
const _hoisted_2 = { class: "body__title" }
const _hoisted_3 = {
  key: 0,
  class: "dropdown"
}

import router from "@/router";
import { removeToken } from "@/utils/token";
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { User01, LogOut01 } from "utruckin-icons";
import { useUserStore } from "@/features/users/user.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'WidgetProfile',
  setup(__props) {

const userStore = useUserStore();

const profileRef = ref<HTMLElement | null>(null);
const isOpen = ref(false);

const toggle = () => {
  isOpen.value = !isOpen.value;
};

const signOut = () => {
  removeToken();
  router.push("/auth");
};

const onOutsideClick = (e: MouseEvent) => {
  if (!profileRef.value?.contains(e.target as Node)) {
    isOpen.value = false;
  }
};

const log = computed(() => {
  if (!userStore.userProfile?.name) return "";

  return userStore.userProfile.name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .join("");
});

onMounted(() => {
  document.addEventListener("mousedown", onOutsideClick);
});

onBeforeUnmount(() => {
  document.removeEventListener("mousedown", onOutsideClick);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-profile",
    ref_key: "profileRef",
    ref: profileRef
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["body", { active: isOpen.value }]),
      onClick: toggle
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(log.value), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(userStore).userProfile?.name), 1)
    ], 2),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "dropdown__item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/profile')))
          }, [
            _createVNode(_unref(User01), { size: 16 }),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Profile", -1))
          ]),
          _createElementVNode("div", {
            class: "dropdown__item dropdown__item--danger",
            onClick: signOut
          }, [
            _createVNode(_unref(LogOut01), { size: 16 }),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Log out", -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})